import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Stack,
    TextField,
} from "@mui/material";
import AppDatePicker from "../../shared/AppDatePicker";

export default function PerformanceDialog({
    open,
    editingPerformanceIndex,
    currentPerformance,
    performanceErrors,
    articles,
    onClose,
    onSave,
    onFieldChange,
    onArticleChange,
}) {
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>{editingPerformanceIndex !== null ? "Leistung bearbeiten" : "Leistung hinzufügen"}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <AppDatePicker
                        label="Datum"
                        value={currentPerformance.date}
                        onChange={(date) => onFieldChange("date", date)}
                        fullWidth
                        error={Boolean(performanceErrors.date)}
                        helperText={performanceErrors.date || ""}
                    />
                    <TextField
                        select
                        label="Artikel"
                        value={currentPerformance.articleId}
                        onChange={(event) => onArticleChange(event.target.value)}
                        fullWidth
                        error={Boolean(performanceErrors.articleId)}
                        helperText={performanceErrors.articleId || ""}
                    >
                        <MenuItem value=""></MenuItem>
                        {currentPerformance.articleId &&
                            !articles.some((article) => article?.id === currentPerformance.articleId) && (
                                <MenuItem value={currentPerformance.articleId}>
                                    {currentPerformance.articleName || "Unbekannter Artikel"}
                                </MenuItem>
                            )}
                        {articles
                            .filter((article) => article?.id)
                            .map((article) => (
                                <MenuItem key={article.id} value={article.id}>
                                    {article.name || article.articleNumber || "Unbenannter Artikel"}
                                </MenuItem>
                            ))}
                    </TextField>
                    <TextField
                        label="Menge (z. B. Stunden)"
                        type="number"
                        value={currentPerformance.amount}
                        onChange={(event) => onFieldChange("amount", event.target.value)}
                        fullWidth
                        inputMode="decimal"
                        inputProps={{ step: "0.25", min: "0" }}
                        error={Boolean(performanceErrors.amount)}
                        helperText={performanceErrors.amount || ""}
                    />
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                        <TextField
                            label="Beginn"
                            type="time"
                            value={currentPerformance.start}
                            onChange={(event) => onFieldChange("start", event.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                        <TextField
                            label="Ende"
                            type="time"
                            value={currentPerformance.end}
                            onChange={(event) => onFieldChange("end", event.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Stack>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit">
                    Abbrechen
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2, color: "#000" }}
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
